/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg version="1.1" width="52" height="52" viewBox="0 0 52 52" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <circle cx="26" cy="26" r="25" fill="none" stroke="#ffb81c" strokeWidth="2"/><path fill="#0e497b" d="M23.13 34.34L14 25.21l1.8-1.8 7.33 7.32L35.85 18l1.81 1.8-14.53 14.54z" fillRule="evenodd"/>
</svg>
    );
  }
}

Icon.displayName = 'CheckmarkWithBorderIcon';

export default Icon;
